let VIEW_HANDLER = {
  active: 'Active',
  setup_automations: 'SetupAutomations',
}

export function getView(value) {
  return VIEW_HANDLER[value] || 'Inactive'
}
